import {NgModule} from '@angular/core';
import {InputModule} from './controls/input/input.module';
import {FormsModule as NgFormsModule} from '@angular/forms';
import {DatepickerModule} from './controls/datepicker/datepicker.module';
import {FileInputModule} from './controls/file/file-input.module';
import {AddresspickerModule} from './controls/addresspicker/addresspicker.module';
import {FormValidationModule} from './validation/form-validation.module';
import {MonthPickerModule} from './controls/monthpicker/month-picker.module';
import {SelectorModule} from './controls/selector/selector.module';
import {MultiselectorModule} from './controls/multiselector/multiselector.module';
import {YesNoSelectorModule} from './controls/yesno/selector/yes-no-selector.module';
import {SignatureInputModule} from './controls/signature/signature-input.module';
import {FormManager} from './form-manager.class';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [
        InputModule,
        SelectorModule,
        FormValidationModule,
        DatepickerModule,
        AddresspickerModule,
        MonthPickerModule,
        FileInputModule,
        MultiselectorModule,
        YesNoSelectorModule,
        SignatureInputModule
    ],
    providers: [FormManager.InjectedMembers],
    exports: [
        NgFormsModule,
        InputModule,
        SelectorModule,
        FormValidationModule,
        DatepickerModule,
        AddresspickerModule,
        MonthPickerModule,
        FileInputModule,
        MultiselectorModule,
        YesNoSelectorModule
    ]
})
export class FormsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/forms.module.ts